import { useState, useEffect, useCallback } from 'react';
import { useParams } from 'react-router';
import { api } from '@/services/api';
import { removeAuthObject } from '@/utils/auth';
import { BaseFormModal } from '@/components/BaseFormModal';

export function RegistrationScreen() {
  const { code } = useParams<{ code: string }>();

  const [username, setUsername] = useState('');
  const [formVisible, setFormVisible] = useState(true);
  const [password, setPassword] = useState('');
  const [passwordRepeat, setPasswordRepeat] = useState('');
  const [acceptTerms, setAcceptTerms] = useState(false);
  const [registering, setRegistering] = useState(false);
  const [successOpen, setSuccessOpen] = useState(false);

  useEffect(() => {
    removeAuthObject();
    if (!code) return;
    api.getUsernameForRegistration(code).then(
      (result) => setUsername(result.username),
      () => {
        setUsername('Registration code invalid or expired. Please contact your administrator for a new registration email.');
        setFormVisible(false);
      }
    );
  }, [code]);

  const submitRegistration = useCallback(async () => {
    setRegistering(true);
    try {
      await api.register({
        registrationCode: code,
        newPassword1: password,
        newPassword2: passwordRepeat,
        readTerms: acceptTerms,
      });
      setSuccessOpen(true);
    } catch {
      // Error handled by API
    }
    setRegistering(false);
  }, [code, password, passwordRepeat, acceptTerms]);

  return (
    <>
      <BaseFormModal
        open={successOpen}
        title="Registration Successful"
        showCancel={false}
        saveText="Sign In"
        onSave={() => { window.location.href = '/'; }}
        onCancel={() => {}}
      >
        <p>Please click the "Sign In" button below to go to the sign in screen.</p>
      </BaseFormModal>

      <div id="divContainer" style={{ paddingLeft: 0, paddingRight: 0 }}>
        <div className="kstc-row">
          <section id="SectionSignIn" className="form-signin">
            <div className="limiter">
              <div className="container-login100">
                <div className="login100-more" style={{ backgroundImage: "url('/Content/Customize/img/login-2-v1.jpg')", zIndex: 'auto' }}></div>
                <div className="waveWrapper waveAnimation">
                  <div className="waveWrapperInner bgTop">
                    <div className="wave waveTop" style={{ backgroundImage: "url('/Content/Customize/img/Wave-top.png')" }}></div>
                  </div>
                  <div className="waveWrapperInner bgMiddle">
                    <div className="wave waveMiddle" style={{ backgroundImage: "url('/Content/Customize/img/Wave-mid.png')" }}></div>
                  </div>
                  <div className="waveWrapperInner bgBottom">
                    <div className="wave waveBottom" style={{ backgroundImage: "url('/Content/Customize/img/wave-bot.png')" }}></div>
                  </div>
                </div>
                <div className="wrap-login100">
                  <form className="login100-form validate-form p-l-50 p-r-50 p-t-72" onSubmit={(e) => { e.preventDefault(); submitRegistration(); }}>
                    <span className="login100-form-title p-b-59">Registration</span>
                    <p className="input100">{username}</p>

                    {formVisible && (
                      <>
                        <div className="wrap-input100 validate-input" data-validate="Password is required">
                          <span className="label-input100">Password</span>
                          <input className="input100" type="password" placeholder="**********" value={password} onChange={(e) => setPassword(e.target.value)} autoComplete="new-password" required />
                          <span className="focus-input100"></span>
                        </div>
                        <div className="wrap-input100 validate-input" data-validate="Password is required">
                          <span className="label-input100">Repeat password</span>
                          <input className="input100" type="password" placeholder="**********" value={passwordRepeat} onChange={(e) => setPasswordRepeat(e.target.value)} autoComplete="new-password" required />
                          <span className="focus-input100"></span>
                        </div>
                        <div className="kstc-check" style={{ marginBottom: '20px' }}>
                          <input className="kstc-check__input" type="checkbox" checked={acceptTerms} onChange={(e) => setAcceptTerms(e.target.checked)} id="registrationAcceptTermsAndConditions" />
                          <label className="kstc-check__label" htmlFor="registrationAcceptTermsAndConditions">
                            Accept Terms &amp; Conditions and Privacy Policy
                          </label>
                        </div>
                        <button type="submit" disabled={registering} className="kstc-btn kstc-btn--primary kstc-btn--lg" style={{ width: '100%' }}>
                          {!registering ? <span>Register</span> : <span><span className="kstc-spinner kstc-spinner--sm"></span> Registering...</span>}
                        </button>
                      </>
                    )}
                  </form>
                  <footer className="login-footer">
                    <a target="_blank" href="//kerkton.com/terms" rel="noreferrer">Terms &amp; Conditions</a> | <a target="_blank" href="//kerkton.com/privacy" rel="noreferrer">Privacy Policy</a>
                  </footer>
                </div>
              </div>
            </div>
          </section>
        </div>
      </div>
    </>
  );
}
